import { Rpc } from '../rpc';
import { RpcObservableServer } from '../rpc-observable-server';
import {
    RpcObservableUpdateThemeError, RpcObservableUpdateThemeKey,
    RpcObservableUpdateThemeRequest, RpcObservableUpdateThemeResult
} from './rpc-observable-update-theme-model';

export class RpcObservableUpdateThemeServer
    extends RpcObservableServer<RpcObservableUpdateThemeRequest,
    RpcObservableUpdateThemeResult, RpcObservableUpdateThemeError> {

    /**
     * Initializes a new instance of the RpcObservableUpdateThemeServer class.
     *
     * @param rpc the rpc object.
     */
    constructor(rpc: Rpc) {
        super(rpc, RpcObservableUpdateThemeKey.command, RpcObservableUpdateThemeKey.version);
    }
}
